import { ARBITRUM, BSC, AVALANCHE_FUJI, BESC } from "config/chains";
import { getContract } from "config/contracts";

const ARBITRUM_MONEY = getContract(ARBITRUM, "MONEY").toLowerCase();
const BSC_MONEY = getContract(BSC, "MONEY").toLowerCase();
const BESC_MONEY = getContract(BESC, "MONEY").toLowerCase();

type Exchange = {
  name: string;
  icon: string;
  links: { [key: number]: string };
};

export const EXTERNAL_LINKS = {
  [BESC]: {
    networkWebsite: "https://explorer.beschyperchain.com",
    buyMoney: {
      moneyxSwap: `/trade`,
      geckoTerminal: `https://www.geckoterminal.com/besc/tokens/${BESC_MONEY}`,
    },
  },
  [ARBITRUM]: {
    networkWebsite: "https://arbitrum.io/",
    buyMoney: {
      uniswap: `https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=${ARBITRUM_MONEY}`,
      money: `https://moneyxpro.com/#/trade/swap/?mode=market&from=usdc&to=money`,
    },
  },
  [BSC]: {
    networkWebsite: "https://www.ron.network/",
    buyMoney: {
      traderjoe: `https://bescswap.com/swap?outputCurrency=${BSC_MONEY}`,
    },
  },
  [AVALANCHE_FUJI]: {
    networkWebsite: "https://www.ron.network/",
    buyMoney: {
      traderjoe: `https://traderjoexyz.com/trade?outputCurrency=${BSC_MONEY}`,
    },
  },
};

export const FIAT_GATEWAYS: Exchange[] = [
  {
    name: "Banxa",
    icon: "ic_banxa.svg",
    links: {
      [ARBITRUM]: "https://money.banxa.com/?coinType=MONEY&fiatType=USD&fiatAmount=500&blockchain=arbitrum",
      [BSC]: "https://money.banxa.com/?coinType=MONEY&fiatType=USD&fiatAmount=500&blockchain=bsc",
    },
  },
  {
    name: "Transak",
    icon: "ic_tansak.svg",
    links: {
      [ARBITRUM]:
        "https://global.transak.com/?apiKey=28a15a9b-d94e-4944-99cc-6aa35b45cc74&networks=arbitrum&defaultCryptoCurrency=MONEY&isAutoFillUserData=true&hideMenu=true&isFeeCalculationHidden=true",
    },
  },
];

export const MONEY_FROM_ANY_NETWORKS: Exchange[] = [
  {
    name: "Bungee",
    icon: "ic_bungee.png",
    links: {
      [ARBITRUM]: `https://multitx.bungee.exchange/?toChainId=42161&toTokenAddress=${ARBITRUM_MONEY}`,
      [BSC]: `https://multitx.bungee.exchange/?toChainId=2021&toTokenAddress=${BSC_MONEY}`,
    },
  },
  {
    name: "O3",
    icon: "ic_o3.png",
    links: {
      [ARBITRUM]: `https://o3swap.com/swap?dst_chain=42161&dst_token_hash=${ARBITRUM_MONEY}`,
      [BSC]: `https://o3swap.com/swap?dst_chain=2021&dst_token_hash=${BSC_MONEY}`,
    },
  },
];

export const BUY_NATIVE_TOKENS: Exchange[] = [
  {
    name: "Bungee",
    icon: "ic_bungee.png",
    links: {
      [ARBITRUM]: `https://multitx.bungee.exchange/?fromChainId=1&fromTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&toChainId=42161&toTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee `,
      [BSC]: `https://multitx.bungee.exchange/?fromChainId=1&fromTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&toChainId=2021&toTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee`,
    },
  },
  {
    name: "O3",
    icon: "ic_o3.png",
    links: {
      [ARBITRUM]:
        "https://o3swap.com/swap?src_chain=1&dst_chain=42161&dst_token_hash=0x0000000000000000000000000000000000000000",
      [BSC]:
        "https://o3swap.com/swap?src_chain=1&dst_chain=2021&dst_token_hash=0x0000000000000000000000000000000000000000",
    },
  },
  {
    name: "Banxa",
    icon: "ic_banxa.svg",
    links: {
      [ARBITRUM]: "https://money.banxa.com/?coinType=ETH&fiatType=USD&fiatAmount=500&blockchain=arbitrum",
      [BSC]: "https://money.banxa.com/?coinType=RON&fiatType=USD&fiatAmount=500&blockchain=bsc",
    },
  },
  {
    name: "Transak",
    icon: "ic_tansak.svg",
    links: {
      [ARBITRUM]:
        "https://global.transak.com/?apiKey=28a15a9b-d94e-4944-99cc-6aa35b45cc74&networks=arbitrum&isAutoFillUserData=true&hideMenu=true&isFeeCalculationHidden=true",
      [BSC]:
        "https://global.transak.com/?apiKey=28a15a9b-d94e-4944-99cc-6aa35b45cc74&networks=roncchain&defaultCryptoCurrency=RON&isAutoFillUserData=true&hideMenu=true&isFeeCalculationHidden=true",
    },
  },
];

export const TRANSFER_EXCHANGES: Exchange[] = [
  {
    name: "Binance",
    icon: "ic_binance.svg",
    links: {
      [ARBITRUM]: "https://www.binance.com/en/trade/",
      [BSC]: "https://www.binance.com/en/trade/",
    },
  },
  {
    name: "Synapse",
    icon: "ic_synapse.svg",
    links: {
      [ARBITRUM]: "https://synapseprotocol.com/?inputCurrency=ETH&outputCurrency=ETH&outputChain=42161",
      [BSC]: "https://synapseprotocol.com/",
    },
  },
  {
    name: "Ronin",
    icon: "ic_arbitrum_24.svg",
    links: {
      [ARBITRUM]: "https://bridge.arbitrum.io/",
    },
  },
  {
    name: "Bsc",
    icon: "ic_ron_30.svg",
    links: {
      [BSC]: "https://bridge.ron.network/",
    },
  },
  {
    name: "Hop",
    icon: "ic_hop.svg",
    links: { [ARBITRUM]: "https://app.hop.exchange/send?token=ETH&sourceNetwork=ethereum&destNetwork=arbitrum" },
  },
  {
    name: "Bungee",
    icon: "ic_bungee.png",
    links: {
      [ARBITRUM]:
        "https://multitx.bungee.exchange/?fromChainId=1&fromTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&toChainId=42161&toTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
      [BSC]:
        "https://multitx.bungee.exchange/?fromChainId=1&fromTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&toChainId=2021&toTokenAddress=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    },
  },
  {
    name: "O3",
    icon: "ic_o3.png",
    links: {
      [ARBITRUM]:
        "https://o3swap.com/swap?src_chain=1&dst_chain=42161&dst_token_hash=0x0000000000000000000000000000000000000000",
      [BSC]:
        "https://o3swap.com/swap?src_chain=1&dst_chain=2021&dst_token_hash=0x0000000000000000000000000000000000000000",
    },
  },
  {
    name: "Across",
    icon: "ic_across.svg",
    links: { [ARBITRUM]: "https://across.to/bridge?from=1&to=42161&asset=ETH" },
  },
];

export const CENTRALISED_EXCHANGES: Exchange[] = [
  {
    name: "Binance",
    icon: "ic_binance.svg",
    links: {
      [ARBITRUM]: "https://www.binance.com/en/trade/MONEY_USDT",
      [BSC]: "https://www.binance.com/en/trade/MONEY_USDT",
    },
  },
  {
    name: "Bybit",
    icon: "ic_bybit.svg",
    links: {
      [ARBITRUM]: "https://www.bybit.com/en-US/trade/spot/MONEY/USDT",
      [BSC]: "https://www.bybit.com/en-US/trade/spot/MONEY/USDT",
    },
  },
  {
    name: "Kucoin",
    icon: "ic_kucoin.svg",
    links: {
      [ARBITRUM]: "https://www.kucoin.com/trade/MONEY-USDT",
      [BSC]: "https://www.kucoin.com/trade/MONEY-USDT",
    },
  },
  {
    name: "Huobi",
    icon: "ic_huobi.svg",
    links: {
      [ARBITRUM]: "https://www.huobi.com/en-us/exchange/money_usdt/",
      [BSC]: "https://www.huobi.com/en-us/exchange/money_usdt/",
    },
  },
];

export const DECENTRALISED_AGGRIGATORS: Exchange[] = [
  {
    name: "1inch",
    icon: "ic_1inch.svg",
    links: {
      [ARBITRUM]: "https://app.1inch.io/#/42161/unified/swap/ETH/MONEY",
      [BSC]: "https://app.1inch.io/#/2021/unified/swap/RON/MONEY",
    },
  },
  {
    name: "Matcha",
    icon: "ic_matcha.png",
    links: {
      [ARBITRUM]: `https://www.matcha.xyz/markets/42161/${ARBITRUM_MONEY}`,
      [BSC]: `https://www.matcha.xyz/markets/2021/${BSC_MONEY}`,
    },
  },
  {
    name: "Paraswap",
    icon: "ic_paraswap.svg",
    links: {
      [ARBITRUM]: `https://app.paraswap.io/#/${ARBITRUM_MONEY}?network=arbitrum`,
      [BSC]: `https://app.paraswap.io/#/${BSC_MONEY}?network=bsc`,
    },
  },
  {
    name: "KyberSwap",
    icon: "ic_kyberswap.svg",
    links: {
      [ARBITRUM]: "https://kyberswap.com/swap/arbitrum/eth-to-money",
      [BSC]: "https://kyberswap.com/swap/bsc/ron-to-money",
    },
  },
  {
    name: "OpenOcean",
    icon: "ic_openocean.svg",
    links: {
      [ARBITRUM]: "https://app.openocean.finance/CLASSIC#/ARBITRUM/ETH/MONEY",
      [BSC]: "https://app.openocean.finance/CLASSIC#/RON/RON/MONEY",
    },
  },
  {
    name: "DODO",
    icon: "ic_dodo.svg",
    links: {
      [ARBITRUM]: `https://app.dodoex.io/?from=ETH&to=${ARBITRUM_MONEY}&network=arbitrum`,
      [BSC]: `https://app.dodoex.io/?from=RON&to=${BSC_MONEY}&network=bsc`,
    },
  },
  {
    name: "Slingshot",
    icon: "ic_slingshot.svg",
    links: { [ARBITRUM]: "https://app.slingshot.finance/swap/ETH?network=arbitrum" },
  },
  {
    name: "Yieldyak",
    icon: "ic_yield_yak.png",
    links: {
      [BSC]: `https://yieldyak.com/swap?outputCurrency=${BSC_MONEY}`,
    },
  },
  {
    name: "Firebird",
    icon: "ic_firebird.png",
    links: {
      [ARBITRUM]: "https://app.firebird.finance/swap",
      [BSC]: "https://app.firebird.finance/swap",
    },
  },
  {
    name: "Odos",
    icon: "ic_odos.png",
    links: {
      [ARBITRUM]: "https://app.odos.xyz/swap/42161/ETH/MONEY",
      [BSC]: "https://app.odos.xyz/swap/2021/RON/MONEY",
    },
  },
];
